const submitAddtlTaxFeesForm = (values, dispatch, props) => {
  props.toggleModal();
};

export default submitAddtlTaxFeesForm;
